enum BusinessRuleCategory {
  ComboConversion = 'item_substitution',
  DefaultSizeSelection = 'default_size_selection',
  ComboSizeTransformation = 'combo_size_propagation',
  ALaCarteConversion = 'a_la_carte_conversion',
}
enum BusinessRuleOption {
  ConvertToCombo = 'front_end_substitute_item',
  SelectDefaultSize = 'select_default_size',
  TransformComboSize = 'propagate_combo_size',
  ConvertToALaCarte = 'convert_to_a_la_carte',
}
enum MenuModuleErrorType {
  unmatchedItems = 'unmatched_items',
  unavailableItems = 'unavailable_items',
  invalidConstraints = 'invalid_constraints',
}
enum UnavailabilityReason {
  outOfStock = 'out_of_stock',
  notSold = 'not_sold',
}
// Normalized reason for a single failing cart node, derived from the
// menu-module error_type (and unavailability_reason where applicable).
enum CartErrorReason {
  notSold = 'not_sold',
  outOfStock = 'out_of_stock',
  unmatched = 'unmatched',
  missingModifier = 'missing_modifier',
  // Failure reported by the menu module that couldn't be resolved to cart
  // nodes (unrecognized error_type or unparseable detail). Carries no path,
  // so it only surfaces in the order-level banner, never on a cart line.
  unknown = 'unknown',
}
enum EntityType {
  item = 'item',
  constraint = 'constraint',
}

export {
  BusinessRuleOption,
  BusinessRuleCategory,
  MenuModuleErrorType,
  UnavailabilityReason,
  CartErrorReason,
  EntityType,
};
